/**
 * Reprise de l'historique de la rémunération (lot 3). Constantes à part de
 * `finance.ts` pour que la reprise reste un ajout pur au socle.
 */

/** Plafond de fiches traitées par appel de recalcul (la suite via `nextCursor`). */
export const FINANCE_BACKFILL_MAX_LEADS = 2000;

/** Taille d'un lot de lecture (fiches par `findMany`). */
export const FINANCE_BACKFILL_BATCH_SIZE = 100;

/** Actions tracées dans `finance_access_logs` par la reprise. */
export const FINANCE_BACKFILL_ACTIONS = [
  'backfill.historical_tariffs',
  'backfill.recompute',
] as const;
export type FinanceBackfillAction = (typeof FINANCE_BACKFILL_ACTIONS)[number];
